// extracted by mini-css-extract-plugin
export default {"form":"SettingsUpdateForms_form__u8qmc","field":"SettingsUpdateForms_field__+uRUb","errorText":"SettingsUpdateForms_errorText__qtZda"};